<template>
  <v-app id="app">
    <div v-if="form.loaded" class="print-form">
      <img v-if="branding.printHeader" class="mb-8" :src="branding.printHeader" alt="" />
      <div v-if="$route.params.type === 'inspection'">
        <div class="mb-4">{{ form.date }}</div>
        <div class="d-flex">
          <h1 class="mb-8 font-bold">
            <span class="text-xl" style="line-height: 1.2">{{ form.name }} №{{ form.id }}</span>
          </h1>
        </div>
        <div class="text-lg mb-2">
          Пациент: {{ profile.last_name }} {{ profile.first_name }} {{ profile.middle_name
          }}<span v-if="profile.birthday"
            >, {{ formattedBirthday }} ({{ patientAge }} {{ $utils.pluralForm(patientAge, ["год", "года", "лет"]) }})</span
          ><span v-if="profile.phone">, {{ profile.phone }}</span>
        </div>
        <h2 class="mb-4" v-if="form.type">Тип: {{ form.type.name }}</h2>
        <dynamic-print-form show-mode readonly :schema="formFields" :value="form" :patient-id="Number(customerId)" />

        <div v-if="filesToPreview.length" class="mt-8">
          <div class="mb-2 font-bold">Процесс осмотра</div>

          <div class="row">
            <div class="col-3" v-for="file in filesToPreview" :key="`file-preview-${file.id}`">
              <div class="position-relative">
                <AuthImage title="Нажмите для просмотра" :path="file.path" />
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex mt-10">
          <div class="text-lg mr-11">
            {{ form.author.profession || "Врач" }}:
            {{ form.author.full }}
          </div>
          <div v-if="form.doctor_sign && form.certificate" class="print-shtamp">
            <div class="text-center mb-1">
              Документ подписан<br />
              электронной подписью
            </div>
            <div>Сертификат: {{ form.certificate.SerialNumber.value }}</div>
            <div>
              Владелец:
              {{ sertificateUserName }}
            </div>
            <div>
              Действителен с {{ $date(form.certificate.ValidFromDate.value).format("DD.MM.YYYY") }} по
              {{ $date(form.certificate.ValidToDate.value).format("DD.MM.YYYY") }}
            </div>
          </div>
          <div v-else class="relative">
            /_____________________/
            <div class="absolute w-100 text-center text-xs text-body-2">подпись</div>
          </div>
        </div>
        <div v-if="form.type.id === 1009" class="d-flex mt-10">
          Не является основанием для постановки диагноза. Требуется консультация специалиста.
        </div>
        <img v-if="branding.printFooter" class="mt-8" :src="branding.printFooter" alt="" />
      </div>
    </div>
  </v-app>
</template>
<script>
import { CustomerService } from "@/services/api/customer.service";
import { required } from "vuelidate/lib/validators";
import { messageHelper } from "@/services/validation-helper.js";
import Loader from "@/components/Loader.vue";
import DynamicPrintForm from "@/modules/documents/add-document/DynamicPrintForm.vue";
import { uniqueId } from "lodash/util";
import { API_ERROR_MESSAGE } from "@/config.js";
import { DOCUMENT_AVAILABLE_FIELDS } from "@/modules/documents/add-document/document-available-fields.js";
import imageExtList from "@/services/image-extensions.js";
import { buildDocumentUrl } from "@/services/utils.js";
import AuthImage from "@/components/AuthImage.vue";
import { DynamicFieldsManager } from "@/modules/documents/add-document/dynamic-fields.manager.js";
import { getBrandingConfig } from "@/config";

import { mapState } from "vuex";
export default {
  name: "PrintPage",

  components: { AuthImage, DynamicPrintForm, Loader },

  data() {
    return {
      allowSign: false,
      signed: false,
      sertError: "",
      signServiceInited: false,
      showSertList: false,
      formTitle: "Добавить документ",
      loadingForm: false,
      loadingShowModeForm: false,

      loadingTypes: false,
      eventsTypes: [],
      formFields: [],
      formSchema: [],
      formDynamicValidation: {
        category: { required },
      },

      form: {
        loaded: false,
        author: "",
        category: "",
        files_to_remove: [],
        name: "",
        real_date: "",
      },

      filesToPreview: [],
      commonErrors: "",
      readyBlocks: 0,
    };
  },

  validations() {
    return {
      form: this.formDynamicValidation,
    };
  },

  computed: {
    branding() {
      return getBrandingConfig();
    },
    ...mapState("customer", ["profile"]),
    customerId() {
      if (this.employeeId) {
        return this.employeeId;
      }

      return this.$store.state.customer.id;
    },

    isShowMode() {
      return this.customerForm !== null;
    },

    typeErrors() {
      return messageHelper(this.$v.form.category);
    },

    sertificateUserName() {
      if (this.form.doctor_sign && this.form.certificate) {
        let res = this.form.certificate.SubjectName.value;
        res = res.split(",");
        let cn = res.find(el => el.includes("CN="));
        cn = cn.split("=")[1];
        return cn;
      }
      return "";
    },

    formattedBirthday() {
      if (this.profile && this.profile.birthday) {
        return this.$date(this.profile.birthday).format("DD.MM.YYYY");
      }
      return "";
    },

    patientAge() {
      if (this.profile && this.profile.birthday) {
        return this.$date().diff(this.$date(this.profile.birthday), "year");
      }
      return 0;
    },
  },

  async created() {
    const r = await CustomerService.getDocument(this.customerId, this.$route.query.document_id);
    await this.readForm(r);
  },
  methods: {
    // const readyBlocks = ref(0);

    doPrint() {
      ++this.readyBlocks;
      if (this.readyBlocks >= this.form.attachments.length ? 2 : 1) {
        setTimeout(() => {
          window.print();
        }, 200);
      }
    },
    /**
     * Хендлер для обновление полей динамической формы
     *
     * @param formData
     */
    updateDynamicForm(formData) {
      this.form = formData;
      this.form.loaded = true;
    },
    async loadData() {
      try {
        const response = await this.$http.get(`v1/documents/types`, { params: { lang: "ru" } });
        this.eventsTypes = response.data.success ? response.data.data : [];
      } catch (e) {
        this.$dialog.notify.error(e.response.message || API_ERROR_MESSAGE);
      }
    },

    /**
     * Загружает для выбранной категории(Типа документа) список полей и сопутствующие данные
     */
    async categorySelect(categoryId) {
      try {
        const response = await this.$http.get(`v1/documents/types/${categoryId}/fields`, { params: { lang: "ru" } });

        if (response.data.success) {
          const formFields = [];

          for (const item of response.data.data) {
            let sourceItems = [];

            if (
              item.type === DOCUMENT_AVAILABLE_FIELDS.source &&
              (item.behavior?.searchable === false || item.source === "icd10")
            ) {
              try {
                const { data } = await this.$http.get(`v1/documents/types/${categoryId}/fields/${item.id}`, {
                  params: { lang: "ru" },
                });
                sourceItems = Array.isArray(data.data) ? this.prepareSourceFieldItems(data.data) : [];
              } catch (e) {
                console.error("Ошибка получения значений справочника");
              }
            }

            formFields.push({ uuid: uniqueId(), ...item, items: sourceItems, addedItems: [] });
          }

          this.formFields = formFields;
          this.form = { ...this.form, ...DynamicFieldsManager.buildForm(formFields) };

          this.formDynamicValidation = DynamicFieldsManager.buildFormValidation(formFields);
        }
      } catch (e) {
        console.log(e);
        this.$dialog.notify.error(e?.response?.message || API_ERROR_MESSAGE);
      }
    },

    /**
     * Читает ответ от сервера и заполняет поля формы
     *
     * @param {CustomerDocument} form
     * @return {Promise<void>}
     */
    async readForm(form) {
      await this.categorySelect(form.type.id);

      const dynamicForm = {};
      this.formTitle = form.name;

      this.eventsTypes = [form.type];
      this.form.category = form.type.id;

      dynamicForm.name = form.name;
      dynamicForm.real_date = form.date;

      // Заполняем поля формы значениями
      if (form.fields.length > 0) {
        form.fields.forEach(field => {
          dynamicForm[`field_${field.id}`] = field.value;
          dynamicForm[`field_${field.id}_display_value`] = field.display_value;
        });
      }

      // Заполняем форму мед. параметрами если они есть
      if (form.med_params.length > 0) {
        for (const field of this.formFields) {
          if (field.type === DOCUMENT_AVAILABLE_FIELDS.params) {
            dynamicForm[field.name] = form.med_params.map(p => {
              const measure = {
                id: p.measure.id,
                name: p.measure.name,
                min: p.norm.min,
                max: p.norm.max,
              };

              return {
                edit: false,
                uuid: p.id,
                param: {
                  id: p.param_id,
                  name: p.name,
                },
                value: p.value,
                measure,
                measures: [measure],
              };
            });
          }
        }
      }
      if (form.med_norms.length > 0) {
        form["field_305"] = form.med_norms.map(p => {
          const measure = {
            id: p.measure.id,
            name: p.measure.name,
            min: p.min_value,
            max: p.max_value,
          };
          return {
            edit: false,
            uuid: p.id,
            param: {
              id: p.param_id,
              name: p.name,
            },
            min_value: p.min_value,
            max_value: p.max_value,
            measure,
            measures: [measure],
          };
        });
      }
      // Проверяем есть ли прикрепленные файлы
      if (form.attachments.length > 0) {
        dynamicForm["attach_files"] = form.attachments;
        this.filesToPreview = form.attachments
          .filter(file => imageExtList.includes(file.extension))
          .map(file => {
            return { ...file, path: buildDocumentUrl(this.customerId, file.id) };
          });
      }

      this.updateDynamicForm({ ...form, ...dynamicForm });

      // Получения значений для справочников
      for (const item of this.formFields) {
        if (item.type === DOCUMENT_AVAILABLE_FIELDS.source && item?.behavior?.searchable && dynamicForm[item.name]) {
          try {
            const { data } = await this.$http.get(`v1/documents/types/${form.type.id}/fields/${item.id}`, {
              params: { lang: "ru", id: JSON.parse(dynamicForm[item.name]).map(Number) },
            });

            item.addedItems = data.data;
          } catch (e) {
            console.log(`e =>`, e);
            console.error("Ошибка получения значения справочника");
          }
        }
      }

      this.loadingShowModeForm = true;
      this.loadingForm = false;
      this.doPrint();
    },

    /**
     * Подготавливает поля справочника для UI
     */
    prepareSourceFieldItems(items) {
      return items;
    },
  },
};
</script>
<style lang="scss">
@page {
  size: A4;
  margin: 0;
}
@media print {
  html,
  body {
    width: 210mm;
    height: 297mm;
  }
  /* ... the rest of the rules ... */
}
.print-form {
  padding: 2cm 1cm 2cm 3cm;
  font-size: 14px;
  line-height: 150%;
  font-family: "Roboto", sans-serif;
  img {
    max-width: 100%;
  }
  * {
    color: #000 !important;
  }
  .pos {
    border: 1px #000 solid;
    &.error {
      box-shadow: inset 0 0 0 5px #000;
    }
    &.success {
      box-shadow: inset 0 0 0 5px #888;
    }
  }
  table {
    border-collapse: collapse;
    td {
      border: 1px solid;
      padding: 3px 5px;
    }
  }
}
.print-shtamp {
  padding: 8px;
  border: 1px solid;
  border-radius: 16px;
  font-size: 10px;
  line-height: 120%;
  margin-left: auto;
}
</style>
